export const currencySymbol = "$";
